




























import { NullableNumber, NullableString } from "@/code/Types";
import { clientsStore } from "@/store/modules/ClientStore";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class extends Vue {
  get clientName(): NullableString {
    return `${clientsStore.current.clientFirstName} ${clientsStore.current.clientLastName}`;
  }

  get dateOfBirth(): NullableString {
    return moment(clientsStore.current.clientDateOfBirth).format("MM/DD/YYYY");
  }

  get age(): NullableNumber {
    return clientsStore.current.clientAge;
  }

  get gender(): NullableString {
    return clientsStore.current.clientGender;
  }
}
